'use client'
import Script from 'next/script'
import React, { useEffect } from 'react'

//import type { GAParams } from '../types/google'
type GAParams = {
  gaId: string
  linkerDomains: string[]
  dataLayerName?: string
  nonce?: string
}

declare global {
  interface Window {
    dataLayer?: Object[]
  }
}
let currDataLayerName: string | undefined = undefined

// COPY FROM: https://github.com/vercel/next.js/blob/canary/packages/third-parties/src/google/ga.tsx
export function GoogleAnalytics(props: GAParams) {
  const { gaId, dataLayerName = 'dataLayer', nonce, linkerDomains } = props

  if (currDataLayerName === undefined) {
    currDataLayerName = dataLayerName
  }

  useEffect(() => {
    // performance.mark is being used as a feature use signal. While it is traditionally used for performance
    // benchmarking it is low overhead and thus considered safe to use in production and it is a widely available
    // existing API.
    // The performance measurement will be handled by Chrome Aurora

    performance.mark('mark_feature_usage', {
      detail: {
        feature: 'next-third-parties-ga',
      },
    })
  }, [])

  return (
    <>
      <Script
        id="_next-ga-init"
        dangerouslySetInnerHTML={{
          __html: `
          window['${dataLayerName}'] = window['${dataLayerName}'] || [];
          function gtag(){window['${dataLayerName}'].push(arguments);}
          gtag('js', new Date());

          gtag('config', '${gaId}', { 'linker': { 'domains': ${JSON.stringify(linkerDomains)} } });`,
        }}
        nonce={nonce}
      />
      <Script id="_next-ga" src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`} nonce={nonce} />
    </>
  )
}
